// 로그인 상태 및 메뉴 목록을 전역으로 관리하는 Context
import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getCurrentUser } from '../api/auth';
import { getMyMenus } from '../api/menu';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser]   = useState(null);
  const [menus, setMenus] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMenus = useCallback(async () => {
    try {
      const res = await getMyMenus();
      setMenus(res.menus || []);
    } catch {
      setMenus([]);
    }
  }, []);

  // 페이지 새로고침 시 로컬스토리지에서 사용자 정보 복원 + 메뉴 재로드
  useEffect(() => {
    const savedUser = getCurrentUser();
    if (savedUser) {
      setUser(savedUser);
      fetchMenus();
    }
    setLoading(false);
  }, []); // eslint-disable-line

  const login = async (userData, token) => {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(userData));
    setUser(userData);
    await fetchMenus();
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
    setMenus([]);
  };

  const isAdmin = user?.is_admin === true;

  return (
    <AuthContext.Provider value={{ user, menus, login, logout, isAdmin, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth는 AuthProvider 안에서만 사용 가능합니다.');
  return context;
};
